import anime from 'animejs';
import barba from '@barba/core';
import { routeEvent } from './routeevent';
import { fromTo } from './utils';

barba.hooks.afterEnter((_data) => {
  // Dispatch a custom event so that JS components
  // can re-bind to elements when DOM has been updated

  routeEvent.dispatchEntered();
});

const animationOnce = (container) => {
  anime({
    targets: container,
    opacity: 1,
    duration: 400,
    easing: 'easeInOutSine'
  });
};

const animationEnter = (container) => {
  fromTo(
    { targets: container, opacity: 0, translateY: 20 },
    {
      targets: container,
      opacity: 1,
      translateY: 0,
      duration: 400,
      easing: 'easeInOutSine'
    }
  );
};

const animationLeave = (container, complete) => {
  anime({
    targets: container,
    opacity: 0,
    duration: 250,
    easing: 'easeInOutSine',
    complete
  });
};

barba.init({
  transitions: [
    {
      once({ _next }) {
        animationOnce(document.body);
      },
      enter({ next }) {
        animationEnter(next.container);
      },
      leave: ({ current }) => {
        return new Promise((resolve) => {
          animationLeave(current.container, resolve);
        });
      }
    }
  ]
  // ...
});
